import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { GridState, NamedEntity } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class TasksService {
  private apiUrl: string = environment.apiUrl;
  constructor(private httpClient: HttpClient) {}

  getAllTasks(state: GridState): Observable<GridDataResult> {
    return this.httpClient.get<GridDataResult>(
      `${this.apiUrl}/admin/tasks/all?${toDataSourceRequestString(state)}`,
    );
  }

  invokeAPI(request: {
    apiName: string;
    restaurantNumbers?: string[];
    reportingUnit?: number;
    syncOption?: string;
  }) {
    return this.httpClient.post<any>(
      `${this.apiUrl}/admin/tasks/invoke/${request.apiName}`,
      {
        restaurantNumbers: request.restaurantNumbers,
        reportingUnit: request.reportingUnit,
        syncOption: request.syncOption,
      },
    );
  }

  getFlowerTaskDetails(taskId: string): Observable<any> {
    return this.httpClient.get<any>(
      `${environment.flowerBaseUrl}/api/task/info/${taskId}`,
    );
  }

  getTaskApiList(): Observable<NamedEntity[]> {
    const url = `${this.apiUrl}/admin/tasks/taskapilist`;
    return this.httpClient.get<NamedEntity[]>(url);
  }
}
